export const LinkageApiKeyApiPath = {
  LIST_LINKAGE_API_KEYS: '/api/linkage-api-keys', // GET List Linkage Api Keys
  CREATE_LINKAGE_API_KEY: '/api/linkage-api-keys', // POST Create Linkage Api Key
  UPDATE_LINKAGE_API_KEY: '/api/linkage-api-keys/{linkage_api_key_id}', // PUT Update Linkage Api Key
  DELETE_LINKAGE_API_KEY: '/api/linkage-api-keys/{linkage_api_key_id}' // DELETE Delete Linkage Api Key
}

export type LinkageApiKeyApiPath =
  (typeof LinkageApiKeyApiPath)[keyof typeof LinkageApiKeyApiPath]

export type ListLinkageApiKeysVars = Record<string, never>

export interface CreateLinkageApiKeyVars {
  purpose: string
  allowed_ips: string[]
}

export interface UpdateLinkageApiKeyVars {
  linkage_api_key_id: number
  purpose: string
  allowed_ips: string[]
}

export interface DeleteLinkageApiKeyVars {
  linkage_api_key_id: number
}

import { LinkageApiKey } from '@/common/model/linkageApiKey'

export type ListLinkageApiKeysResponse = LinkageApiKey[]
export type CreateLinkageApiKeyResponse = LinkageApiKey
export type UpdateLinkageApiKeyResponse = LinkageApiKey

export interface DeleteLinkageApiKeyResponse {
  deleted: boolean
}
